<template>
    <footer id="footer">
        <b-container>
            <b-row align-v="center">
                <b-col cols="3" class="text-center">
                    <img
                    src="../assets/img/ucv.gif"
                    alt="Logo Universidad Central de Venezuela"
                    >
                </b-col>
                <b-col cols="6" class="text-center">
                    <div>Universidad Central de Venezuela - Facultad de Ciencias.</div>
                </b-col>
                <b-col cols="3" class="text-center">
                    <img
                    src="../assets/img/ciens.png"
                    alt="Logo Facultad de Ciencias"
                    >
                </b-col>
            </b-row>
        </b-container>
    </footer>
</template>

<script>
export default {
    name: 'TheFooter',
    data () {
        return {}
    }
}
</script>

<style>
#footer{
    background-color: #F5F5F5;
    padding: 15px 0px;
}
</style>
